import { PopUp } from './pop-up';

export class PopUpSerializer {

  fromJson(json: any): PopUp {
    const sf = new PopUp();
    if (typeof json.success !== 'undefined') {
      sf.success = json.success;
      sf.data = this.toJson(json.data);
      return sf;
    } else {
      return this.toJson(json);
    }
  }

  toJson(sf: PopUp): any {
    if (typeof sf === 'object') {
      return {
        id: sf.id,
        name: sf.name,
        allow_close_popup: sf.allow_close_popup,
        maximum_width: sf.maximum_width,
        maximum_height: sf.maximum_height,
        totvs_query: sf.totvs_query,
        query: sf.query,
        applicantData: sf.applicantData,
        client_id: sf.client_id,
        content: sf.content,
        updated_at: sf.updated_at,
        edited_by: sf.edited_by,
        use_totvs_oracle: sf.use_totvs_oracle
      };
    } else {
      return sf;
    }
  }
}
